import { defineComponent as _defineComponent } from 'vue';
import { useSlots } from 'vue';
import { useI18n } from 'vue-i18n';
import EnIcon from 'Components/icons/EnIcon.vue';
import EnExportIcon from 'Components/icons/EnExportIcon.vue';
import EnFilterVisibilityMenu from 'Components/datagrid/actions/EnFilterVisibilityMenu.vue';
import EnColumnVisibilityMenu from 'Components/datagrid/actions/EnColumnVisibilityMenu.vue';
import { EnButton } from '../../base/EnButton';
import { Plus } from 'lucide-vue-next';
import EnDataGridActionsMenu from '../slots/EnDatagridActionsMenu.vue';
import { useIdBuilder } from '../composables/useIdBuilder';
import EnTooltip from 'Components/base/EnTooltip/EnTooltip.vue';
import { EnMenu } from 'Components/base/EnMenu';
import { EnItem } from 'Components/base/EnItem';
import { Download } from 'lucide-vue-next';
/**
 * A simple bar to place filter buttons in. Mainly used for EnDataGrid.
 */
export default /*@__PURE__*/ _defineComponent({
    __name: 'EnFilterBar',
    props: {
        /**
         * Specifies whether the filter options are shown (true) or not (false).
         */
        showFilterOptions: Boolean,
        /**
         * Function to reset individual filter.
         */
        resetIndividualFilter: Function,
        /**
         * List of filter buttons.
         */
        filterButtons: {
            default: [],
            type: (Array)
        },
        /**
         * If true, export button is shown.
         */
        showExportButton: Boolean,
        /**
         * Function to export all data.
         */
        exportAllData: Function,
        /**
         * List of columns of Datagrid
         * Necessary for toggling their visibility
         */
        columns: Array,
        /**
         * Function to show all columns.
         */
        showAllColumns: Function,
        restoreDefaultView: Function,
        /**
         * If false, there is nothing to restore and the button is hidden.
         */
        showRestoreDefaultViewButton: Boolean,
        /**
         * Function to display the columns in a new order.
         */
        reorderColumns: Function,
        /**
         * Function to toggle visibility of column.
         */
        toggleVisibilityColumn: Function,
        /**
         * If true, "Add" button is shown
         */
        allowAdding: Boolean,
        /**
         * If true, "Add" button is part of the datagrid and not extracted to the top-panel
         */
        dense: Boolean,
        /**
         * Label of "export" button
         */
        exportToExcelSelectedValuesButtonText: String,
        /**
         * Function to add new item.
         */
        addItem: Function,
        /**
         * Function to export data for selected items in row.
         * Temporary hidden
         */
        exportData: Function,
        /**
         * Key of datagrid.
         */
        dataGridKey: [String, (Array)],
        /**
         * If true, ContextMenu button is shown
         */
        showActionButton: {
            default: true,
            type: Boolean
        },
        /**
         * If true, columns' visibility can be toggled
         */
        showColumnsButton: {
            default: true,
            type: Boolean
        },
        /**
         * Id of the columns' visibility button
         */
        staticId: String,
    },
    emits: ['reset-filters'],
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        const { t } = useI18n();
        const emit = __emit;
        const slots = useSlots();
        const { buildId } = useIdBuilder();
        function getIdForItem(prefix) {
            return buildId(prefix, props.dataGridKey);
        }
        function handleResetFilter() {
            emit('reset-filters');
        }
        const __returned__ = { props, t, emit, slots, buildId, getIdForItem, handleResetFilter, EnIcon, EnExportIcon, EnFilterVisibilityMenu, EnColumnVisibilityMenu, get EnButton() { return EnButton; }, get Plus() { return Plus; }, EnDataGridActionsMenu, EnTooltip, get EnMenu() { return EnMenu; }, get EnItem() { return EnItem; }, get Download() { return Download; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
